module.exports = __webpack_public_path__ + "img/institutional_zhouwangmiao.f1a43263.png";